<template>
    <div class="cars-list">
        <template v-for="row in carsRows">
            <div class="car-item-container" v-for="item in row.childArr">
                <a :href="item.href" @click.prevent="goDetail(item)">
                    <div class="car-item"
                        is="CarItem"
                        :data="item"
                        :class="[ 'line-height-level-' + row.lineHeightLevel ]">
                    </div>
                </a>
            </div>
        </template>
    </div>
</template>

<script>
    import './CardBox/CarItemForGrid.vue';
    import './CardBox/CarItemForList.vue';

    import Store from 'store';

    import CarItem from '@souche-f2e/wangzhan-dependencies-car-item';
    import {
        getLineHeightLevel
    } from 'babel!@souche-f2e/wangzhan-dependencies-car-item/src/car-util.js';

    import urlUtil from '@souche-f2e/chunyan-util/url_util/url_util.js';

    import {
        buy
    } from '../../../api/json/car.js';
    import { id as getNearlyShopCarId } from '../../../api/shop/recommend/consignment/car';

    let locationObj = urlUtil.initByLocation();

    export default {
        data() {
            return {
                cars: []
            };
        },
        created() {
            let params = Object.assign({}, locationObj.search._object, {
                aggregateConsignmentFlag: true
            });
            buy(params).then((data) => {
                this.cars = data.items.map((carItem) => {
                    if (carItem.consignmentAggregate) {
                        carItem.href = `/car/${carItem.id}?consignmentAggregate=true`;
                    } else {
                        carItem.href = `/car/${carItem.id}`;
                    }
                    return carItem;
                });
            });
        },
        computed: {
            /**
             * 将车辆列表处理为一个二维数组
             * 每行有四辆车
             * 其中最大高度的车为当前行所有车的高度
             * @Author   Bolt
             * @DateTime 2017-03-09T18:07:42+0800
             * @return   {[type]}                 [description]
             */
            carsRows() {
                let retArr = [];
                for (var i = 0; i < this.cars.length / 4; i++) {
                    let rowObj = {
                        lineHeightLevel: 0,
                        childArr: []
                    };
                    for (var j = 0; j < 4; j++) {
                        let carIndex = i * 4 + j;
                        let carItem = this.cars[carIndex];
                        if (carItem) {
                            let lineHeightLevel = getLineHeightLevel(carItem);
                            if (lineHeightLevel > rowObj.lineHeightLevel) {
                                rowObj.lineHeightLevel = lineHeightLevel;
                            }
                            rowObj.childArr.push(carItem);
                        }
                    }
                    retArr.push(rowObj);
                }
                return retArr;
            }
        },
        methods: {
            goDetail(carItem) {
                let storeCoordinate = Store.get('USER_COORDINATE') || {};
                let coordinate = storeCoordinate.longitude && storeCoordinate.latitude ? `${storeCoordinate.longitude},${storeCoordinate.latitude}` : '';
                if (carItem.consignmentAggregate) {
                    getNearlyShopCarId(carItem.id, carItem.modelCode, coordinate).then((res) => {
                        window.location.href = `/car/${res.carId}?consignmentAggregate=true`;
                    }).catch((err) => {
                        console.log(err);
                        window.location.href = `/car/${carItem.id}?consignmentAggregate=true`;
                    });
                } else {
                    window.location.href = `/car/${carItem.id}`;
                }
            }
        },
        components: {
            CarItem
        }
    };
</script>

<style lang="less" scoped>
.cars-list {
    .car-item-container {
        margin: 0 0 20px 20px;
        float: left;
        .car-item {
            // 无弹个车标且无售价 -22px -29px;
            &.line-height-level-0 {
                height: 343px - 22px - 29px;
            }
            // 无售价 -22px
            &.line-height-level-1 {
                height: 343px - 22px;
            }
            &.line-height-level-2 {
                height: 343px;
            }
        }
    }
    &:after {
        content: '';
        display: block;
        clear: both;
    }
}
</style>



// WEBPACK FOOTER //
// CardBox.vue?657c9d81